import React, { useState } from "react";
import { ModalThemMoiNhanVay } from "./ModalThemMoiNhanVay";

export const BtnThemMoi = ({ quyenThemMoi }) => {
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  return (
    <>
      {quyenThemMoi && (
        <div className="col-sm-12 col-md-10">
          <button
            type="button"
            className="btn btn-border-new"
            onClick={setShow}
          >
            <i className="mdi mdi-plus"></i> Thêm mới
          </button>
        </div>
      )}
      {show && (
        <ModalThemMoiNhanVay show={show} onHide={handleClose} NhanVayID={0} />
      )}
    </>
  );
};
